import { IPharmDashboardRepository } from '../interfaces';
import LogUtil from '../../../core/utils/LogUtil';

export class PharmDashboardRepositoryImpl extends IPharmDashboardRepository {
  constructor(apiClient) {
    super();
    this.apiClient = apiClient;
  }

  async getVisitKpi() {
    try {
      const response = await this.apiClient.get('/pharm-dashboard/visit-kpi');
      return response;
    } catch (error) {
      LogUtil.error('[PharmDashboardRepository] 방문 KPI 조회 실패:', error);
      throw error;
    }
  }

  async getPrescriptionKpi() {
    try {
      const response = await this.apiClient.get('/pharm-dashboard/prescription-kpi');
      return response;
    } catch (error) {
      LogUtil.error('[PharmDashboardRepository] 처방전 KPI 조회 실패:', error);
      throw error;
    }
  }

  async getPatients(page = 1, limit = 20) {
    try {
      const response = await this.apiClient.get('/pharm-dashboard/patients', {
        params: { page, limit },
      });
      return response;
    } catch (error) {
      LogUtil.error('[PharmDashboardRepository] 환자 목록 조회 실패:', error);
      throw error;
    }
  }

  async getCouponSummary(pharmacyBrn) {
    try {
      const response = await this.apiClient.get(`/coupon/dashboard-summary/${pharmacyBrn}`);
      return response;
    } catch (error) {
      LogUtil.error('[PharmDashboardRepository] 쿠폰 현황 조회 실패:', error);
      throw error;
    }
  }

  async getPointSummary(pharmacyBrn) {
    try {
      const response = await this.apiClient.get(`/point/dashboard-summary/${pharmacyBrn}`);
      return response;
    } catch (error) {
      LogUtil.error('[PharmDashboardRepository] 포인트 현황 조회 실패:', error);
      throw error;
    }
  }

  async getActionRequiredKpi() {
    try {
      return await this.apiClient.get('/pharm-dashboard/action-required');
    } catch (error) {
      LogUtil.error('[PharmDashboardRepository] 오늘 응대 필요 조회 실패:', error);
      throw error;
    }
  }

  async getRecommendationHits(pharmacyBrn, params = {}) {
    try {
      return await this.apiClient.get(`/pharm-dashboard/recommendation-hits/${pharmacyBrn}`, { params });
    } catch (error) {
      LogUtil.error('[PharmDashboardRepository] 추천 적중률 조회 실패:', error);
      throw error;
    }
  }

  async getActiveEvents() {
    try {
      return await this.apiClient.get('/pharm-dashboard/active-events');
    } catch (error) {
      LogUtil.error('[PharmDashboardRepository] 진행 중인 이벤트 조회 실패:', error);
      throw error;
    }
  }

  /** GET /pharm-dashboard/ad-campaigns — 우리 약국 대상 제약사 캠페인(예정·진행) + 참여 여부 */
  async getAdCampaigns() {
    try {
      return await this.apiClient.get('/pharm-dashboard/ad-campaigns');
    } catch (error) {
      LogUtil.error('[PharmDashboardRepository] 제약사 캠페인 조회 실패:', error);
      throw error;
    }
  }

  /** POST /pharm-dashboard/ad-campaigns/{id}/join | /leave (본문 없음) */
  async setAdCampaignJoin(campaignId, join) {
    try {
      return await this.apiClient.post(`/pharm-dashboard/ad-campaigns/${campaignId}/${join ? 'join' : 'leave'}`);
    } catch (error) {
      LogUtil.error('[PharmDashboardRepository] 제약사 캠페인 참여 변경 실패:', error);
      throw error;
    }
  }
}
